import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import {useFormik} from 'formik'
import {object, string, mixed} from 'yup'
import {apiErrorsToFormik} from '../../utils/api'
import {appUrl} from '../../utils/urlHelpers'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'

export default function AuthRegistrationForm({onSubmit, onCancel, requestMobilePhone = false}) {
  let validationObject = {
    firstName: string().required(),
    lastName: string().required(),
    email: string().email().required(),
    password: string().required(),
    termsAcceptance: mixed().required()
  }

  if(requestMobilePhone) {
    validationObject.mobilePhone = string().required()
  }

  const validationSchema = object(validationObject)

  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      mobilePhone: ''
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        await onSubmit(values)
      } catch(e) {
        formik.setErrors(apiErrorsToFormik(e))
      } finally {
        formik.setSubmitting(false)
      }
    }
  })

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Form.Group controlId="firstName" className="mb-3">
        <Form.Label>First Name</Form.Label>
        <Form.Control name="firstName" isInvalid={formik.errors.firstName} onChange={formik.handleChange} />
        {formik.errors.firstName &&
          <Form.Control.Feedback type="invalid">
            {formik.errors.firstName}
          </Form.Control.Feedback>
        }
      </Form.Group>

      <Form.Group controlId="lastName" className="mb-3">
        <Form.Label>Last Name</Form.Label>
        <Form.Control name="lastName" isInvalid={formik.errors.lastName} onChange={formik.handleChange} />
        {formik.errors.lastName &&
          <Form.Control.Feedback type="invalid">
            {formik.errors.lastName}
          </Form.Control.Feedback>
        }
      </Form.Group>

      {requestMobilePhone &&
        <Form.Group controlId="mobilePhone" className="mb-3">
          <Form.Label>Phone Number</Form.Label>

          <PhoneInput
            country='gb'
            regions={'europe'}
            containerClass={formik.errors.mobilePhone ? 'is-invalid' : ''}
            inputClass={formik.errors.mobilePhone ? 'is-invalid' : ''}
            onChange={value => { formik.setFieldValue('mobilePhone', value) }}
          />
          {formik.errors.mobilePhone &&
            <Form.Control.Feedback type="invalid">
              {formik.errors.mobilePhone}
            </Form.Control.Feedback>
          }
        </Form.Group>
      }

      <Form.Group controlId="email" className="mb-3">
        <Form.Label>Email</Form.Label>
        <Form.Control name="email" type="email" isInvalid={formik.errors.email} onChange={formik.handleChange} />
        {formik.errors.email &&
          <Form.Control.Feedback type="invalid">
            {formik.errors.email}
          </Form.Control.Feedback>
        }
      </Form.Group>

      <Form.Group controlId="password" className="mb-3">
        <Form.Label>Password</Form.Label>
        <Form.Control name="password" type="password" isInvalid={formik.errors.password} onChange={formik.handleChange} />
        {formik.errors.password &&
          <Form.Control.Feedback type="invalid">
            {formik.errors.password}
          </Form.Control.Feedback>
        }
      </Form.Group>

      <Form.Group controlId="termsAcceptance" className="mb-3">
        <Form.Check type="checkbox" name="termsAcceptance">
          <Form.Check.Input type="checkbox" value={true} isInvalid={formik.errors.termsAcceptance} onChange={formik.handleChange} />
          <Form.Check.Label>
            I accept the
            {' '}
            <a href={`${appUrl('legal/terms')}`} target="_blank" rel="noreferrer">
              Terms & Conditions
            </a>
            {' '}
            and
            {' '}
            <a href={`${appUrl('legal/privacy')}`} target="_blank" rel="noreferrer">
              Privacy Policy
            </a>
          </Form.Check.Label>
          {formik.errors.termsAcceptance &&
            <Form.Control.Feedback type="invalid">
              {formik.errors.termsAcceptance}
            </Form.Control.Feedback>
          }
        </Form.Check>
      </Form.Group>

      <div className="text-end">
        {onCancel &&
          <Button variant="outline-secondary" onClick={onCancel} className="me-2">Cancel</Button>
        }
        <Button type="submit" disabled={formik.isSubmitting}>Register</Button>
      </div>
    </Form>
  )
}
